var i4_Message = {
	initialized: false,	
	timeoutInstance: null,

	initialize: function() {
		this.$element = $('<div></div>').addClass('i4-message');
		$('body').append(this.$element);
		this.$element.append($('<div></div>').addClass('i4-message__text'));
		
		this.initialized = true;
	},
	
	progress: function(){
		if(!this.initialized){ this.initialize(); }
		clearTimeout(this.timeoutInstance);
		
		this.$element.find('.i4-message__text').html(i4_Translation.get().load);
		
		this.$element.
			removeClass('i4-message--hidden').
			addClass('i4-message--shown');
	},
	
	show: function(text){
		if(!this.initialized){ this.initialize(); }
		clearTimeout(this.timeoutInstance);
		
		this.$element.find('.i4-message__text').html(text);
		this.$element.
			removeClass('i4-message--hidden').
			addClass('i4-message--shown');

		this.timeoutInstance = setTimeout((function() {
			this.$element.removeClass('i4-message--shown').addClass('i4-message--hidden');
		}).bind(this), 3000);		
	}
};
